// extracted by mini-css-extract-plugin
export default {"main":"MainButton_main__Ow0WO","logo":"MainButton_logo__LJc94","web_main":"MainButton_web_main__rbIhD"};